import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import Modal from '../components/modal-portal';

var ViewerImage = /*#__PURE__*/function (_React$Component) {
  _inherits(ViewerImage, _React$Component);

  var _super = _createSuper(ViewerImage);

  function ViewerImage(props) {
    var _this;

    _classCallCheck(this, ViewerImage);

    _this = _super.call(this, props);

    _this.toggleBigImage = function (event) {
      event.preventDefault();

      _this.setState({
        isShowBigImage: !_this.state.isShowBigImage
      });
    };

    _this.renderBigImage = function (src) {
      return /*#__PURE__*/React.createElement(BigImage, {
        src: src,
        toggleBigImage: _this.toggleBigImage
      });
    };

    _this.state = {
      isShowBigImage: false
    };
    return _this;
  }

  _createClass(ViewerImage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          attributes = _this$props.attributes,
          node = _this$props.node;
      var data = node.data;
      var isShowBigImage = this.state.isShowBigImage;
      var src = data.src;
      var dom = /*#__PURE__*/React.createElement("span", {
        className: "seafile-ed-image seafile-ed-image-viwer"
      }, /*#__PURE__*/React.createElement("img", Object.assign({
        draggable: false,
        src: src,
        alt: ""
      }, attributes, {
        width: data.width,
        height: data.height
      })), /*#__PURE__*/React.createElement("span", {
        onClick: this.toggleBigImage,
        className: "image-full-button"
      }, /*#__PURE__*/React.createElement("i", {
        className: 'iconfont icon-fullscreen'
      })), isShowBigImage && this.renderBigImage(src));
      return src ? dom : /*#__PURE__*/React.createElement("span", attributes, "Loading...");
    }
  }]);

  return ViewerImage;
}(React.Component);

var BigImage = function BigImage(props) {
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: 'big-image-cover',
    onClick: function onClick(event) {
      return props.toggleBigImage(event);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: 'big-image-container'
  }, /*#__PURE__*/React.createElement("img", {
    src: props.src,
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(event) {
      return props.toggleBigImage(event);
    },
    className: 'image-container-close'
  }, /*#__PURE__*/React.createElement("i", {
    className: 'iconfont icon-close'
  }))));
};

export { ViewerImage };